import config from 'utils/config';

function Security() {
    var roles = config.get('roles') || [];
    this.isGranted = function(role) {
        return roles.indexOf(role) !== -1;
    };
}

module.exports = new Security();
